import {
	PreceptorInterviewProvider,
	usePreceptorInterview,
} from './usePreceptorInterviewWizard';
import { LandingPage } from './LandingPage';
import { WizardProvider } from '../../../components/wizard/useWizard';
import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export const PreceptorContextPolicy = () => {
	const { application, fetchPreceptorByAbhyasiId, updatePreceptorDetails } =
		usePreceptorInterview();
	const { applicant, preceptorReference } = application;
	const screens = useBreakpoint();
	const isMobile = !screens.sm;

	return (
		<div className="flex justify-center">
			<div
				className={`flex flex-col h-full min-h-0 p-[8px] ${
					isMobile ? 'w-full' : 'w-[90%]'
				}`}
			>
				<LandingPage
					applicantInfo={applicant}
					preceptorReference={preceptorReference}
					searchPreceptorByAbhyasiId={fetchPreceptorByAbhyasiId}
					updatePreceptorDetails={updatePreceptorDetails}
				/>
			</div>
		</div>
	);
};

export const PreceptorContextWizardContainer = () => {
	return (
		<PreceptorInterviewProvider>
			<WizardProvider>
				<PreceptorContextPolicy />
			</WizardProvider>
		</PreceptorInterviewProvider>
	);
};
